import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";

const COLOR_CLASSES = {
  red: { badge: "bg-red-100 text-red-700 hover:bg-red-100", hover: "group-hover:border-red-300 group-hover:text-red-700" },
  emerald: { badge: "bg-emerald-100 text-emerald-700 hover:bg-emerald-100", hover: "group-hover:border-emerald-300 group-hover:text-emerald-700" },
  blue: { badge: "bg-blue-100 text-blue-700 hover:bg-blue-100", hover: "group-hover:border-blue-300 group-hover:text-blue-700" },
};

export const RelatedContentBlock = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <section className="section-padding bg-white border-t border-slate-100" data-testid="related-content-block">
      <div className="container-custom max-w-5xl">
        <div className="text-center mb-10">
          <Badge className="bg-slate-100 text-slate-700 px-4 py-2 mb-3 hover:bg-slate-100">
            Maillage interne
          </Badge>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900">
            Vous pourriez aussi aimer
          </h2>
          <p className="text-slate-600 mt-2 text-sm">
            Contenus connexes sélectionnés automatiquement par Mediastore Niort
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item) => (
            <RelatedCard key={`${item.type}-${item.slug}`} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

const RelatedCard = ({ item }) => {
  const cls = COLOR_CLASSES[item.color] || COLOR_CLASSES.red;
  return (
    <Link to={item.path} className="block group" data-testid={`related-link-${item.type}-${item.slug}`}>
      <Card className={`h-full transition-all hover:shadow-md border-slate-200 ${cls.hover}`}>
        <CardContent className="p-5">
          <div className="flex items-center gap-2 mb-3">
            <Badge className={`text-xs ${cls.badge}`}>{item.label}</Badge>
            <span className="text-xs text-slate-500">{item.category}</span>
          </div>
          <h3 className={`font-semibold text-slate-900 transition-colors ${cls.hover} mb-2 line-clamp-2`}>
            {item.title}
          </h3>
          <div className="text-sm text-slate-500 flex items-center gap-1 group-hover:text-slate-700">
            Lire <ArrowRight className="h-3.5 w-3.5" />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};
